import React from 'react';
import s from './FlipAnimator.scss';

const FlipAnimator = ({ children }) => {
  if (!children || children.length !== 2) {
    return null;
  }

  return (
    <div className={s.flipContainer}>
      <div className={s.cardWrap}>
        <div className={`${s.flipCard}  ${s.cardFront}`}>{children[0]}</div>
        <div className={`${s.flipCard} ${s.cardBack}`}>{children[1]}</div>
      </div>
    </div>
  );
};

export default FlipAnimator;
